var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLeftArrowIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 17,
    viewBox: "0 0 19 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.90779 0.325497C9.34336 0.768173 9.34336 1.50302 8.91633 1.95455L3.73222 7.34634H17.8983C18.5046 7.34634 19 7.85984 19 8.49729C19 9.13475 18.5046 9.64825 17.8983 9.64825H3.73222L8.92487 15.04C9.3519 15.4916 9.34336 16.2176 8.91633 16.6691C8.48076 17.1118 7.78898 17.1118 7.35341 16.6602L0.316001 9.31182C0.222055 9.20558 0.145189 9.09048 0.0854055 8.94882C0.0256216 8.80717 0 8.65666 0 8.50615C0 8.20513 0.111028 7.92182 0.316001 7.70048L7.35341 0.352058C7.7719 -0.108325 8.47222 -0.117179 8.90779 0.325497Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLeftArrowIcon);
export default __webpack_public_path__ + "static/media/left-arrow-icon.b25b4208a61e776f28be882689d1b3b0.svg";
export { ForwardRef as ReactComponent };